import React, { useState } from "react";
import { View, StyleSheet, Image, TouchableHighlight, Dimensions, TextInput,  } from "react-native";
import Text from "../Text";
import colors from "../../config/colors";
import { TouchableOpacity } from "react-native-gesture-handler";
import textStyles from "../../config/textStyles";

var windowWidth = Dimensions.get('window').width;
var windowHeight = Dimensions.get('window').height;
var textSmall = (windowWidth * textStyles.textSmall)
var textMedium = (windowWidth * textStyles.textMedium)
var textLarge = (windowWidth * textStyles.textLarge)
var sizeBrainComments = (windowWidth * textStyles.sizeBrainComments)

function ListItemAccount({
    title,
    titleRol,
    titleFollowers,
    subTitleFollowers,
    titleFollowed,
    subTitleFollowed,
    subTitle,
    image,
    IconComponent,
    onPress,
    onPress1,
    onPressGenerateSeed
}) {
    return (
        //    <Swipeable renderRightActions={renderRightActions}>
        <TouchableHighlight underlayColor={colors.light} onPress={onPress}>
            <View style={styles.container}>
                {IconComponent}
                {image && <Image style={styles.image} source={{ uri: image }} />}
                <View style={styles.detailsContainer}>
                    <Text onPress={onPressGenerateSeed} style={styles.title} numberOfLines={1}>
                        {titleRol}
                        {/* <MaterialCommunityIcons
                  color={colors.medium}
                  name="chevron-right"
                  size={25}
              /> */}
                    </Text>
                    {subTitle && (
                        // <TextInput style={styles.subTitle}
                        //     //onChangeText={text => setCommentBoxText(text)}
                        //     value={subTitle}
                        // >

                        // </TextInput>
                        
                            <Text style={styles.subTitle} >
                                {subTitle}
                            </Text>
                        
                    )}
                </View>
                <TouchableOpacity onPress={onPress}>
                    <View style={styles.detailsContainer}>
                        <Text style={styles.titleFollowed} numberOfLines={1}>
                            {titleFollowed}
                        </Text>
                        {subTitle && (
                            <Text style={styles.subTitle} numberOfLines={2}>
                                {subTitleFollowed}
                            </Text>
                        )}
                    </View>
                </TouchableOpacity>
                <TouchableHighlight onPress={onPress1}>
                    <View style={styles.detailsContainer}>
                        <Text style={styles.titleFollowers} numberOfLines={1}>
                            {titleFollowers}
                        </Text>
                        {subTitle && (
                            <Text style={styles.subTitle} numberOfLines={2}>
                                {subTitleFollowers}
                            </Text>
                        )}
                    </View>
                </TouchableHighlight>

                {/*  */}

            </View>
        </TouchableHighlight>
        //</Swipeable>
    );
}

const styles = StyleSheet.create({
    container: {
        borderRadius:10,
      
        marginTop:2,
        alignItems: "center",
        flexDirection: "row",
        padding: 7,
        backgroundColor: colors.fondoGeneral,
        marginBottom: (windowHeight * .002)
    },
    detailsContainer: {
        marginLeft: 10,
        justifyContent: "center",
    },
    image: {
        width: 70,
        height: 70,
        borderRadius: 35,
        borderColor: colors.green,
        borderWidth: 4,
    },
    imageButton: {
        backgroundColor: 'yellow',
        width: 70,
        height: 70,
        borderRadius: 35,
    },
    subTitle: {
        color: colors.medium,
        fontSize: textStyles.textSmall,
        textAlign: 'justify',
        marginRight:"20%"
    },
 
    title: {
        fontSize: textStyles.textSmall,
        color:colors.green,
        fontWeight: "500",
    },
});

export default ListItemAccount;
